export const employmentPeriod = [
  { value: "less_one_year", label: "1年未満" },
  { value: "one_to_three_year", label: "1～3年" },
  { value: "three_to_five_year", label: "3～5年" },
  { value: "over_five_year", label: "5年以上" },
];
export const desiredWithinRange = [
  { value: "five", label: "5km圏内（徒歩通勤）" },
  { value: "ten", label: "10km圏内（自転車通勤）" },
  { value: "thirty", label: "30km圏内（電車・自動車通勤）" },
  { value: "no_limit", label: "30km以上（無制限）" },
];
export const desiredTimeSlot = [
  { value: "day_shift", label: "日勤" },
  { value: "night_shift", label: "夜勤" },
];
export const motivationOfJobChange = [
  { value: "wanting", label: "転職したい" },
  { value: "opportunity", label: "機会があれば転職したい" },
  { value: "thinking", label: "転職を考えている" },
  { value: "not_wanting", label: "転職はしたくない" },
];
export const employmentPeriodConst = [
  { value: "less_one_year", label: "1年未満" },
  { value: "one_to_three_year", label: "1～3年" },
  { value: "three_to_five_year", label: "3～5年" },
  { value: "over_five_year", label: "5年以上" },
] as const;
export type EmploymentPeriod = (typeof employmentPeriodConst)[number]["value"];

export type PenaltyRuleRow = {
  cancelTime: string;
  penaltyPoint: string;
};

// ペナルティルールのデータ（GraphQL 取得失敗時のフォールバック）
export const PENALTY_RULES: PenaltyRuleRow[] = [
  { cancelTime: "24時間より前", penaltyPoint: "0pt" },
  { cancelTime: "~24時間前", penaltyPoint: "-8pt" },
  { cancelTime: "~12時間前まで", penaltyPoint: "-10pt" },
  { cancelTime: "遅刻・早退（合計1時間以下）", penaltyPoint: "-3pt" },
  { cancelTime: "遅刻・早退（合計1時間超）", penaltyPoint: "-5pt" },
];

// インセンティブルールのデータ（WorkerPointModalの正しい内容）
export const INCENTIVE_RULES = [
  { applyTime: "勤務完了+レビュー投稿", incentivePoint: "+1pt" },
];

// 応募制限のデータ
export const APPLICATION_LIMIT_DATA = [
  { points: "初回未勤務", noHistory: "1件", withHistory: "1件" },
  { points: "勤務完了1件", noHistory: "2件", withHistory: "2件" },
  { points: "11pt以上", noHistory: "20件", withHistory: "15件" },
  { points: "6pt-10pt", noHistory: "15件", withHistory: "10件" },
  { points: "0pt-5pt", noHistory: "10件", withHistory: "5件" },
];
